module.exports = __webpack_public_path__ + "static/media/bg2.925218a6.jpg";